import React from "react";
import { connect } from "react-redux";
import { InjectedIntl, injectIntl } from "@ai360/core/intl";
import { DialogBox, DialogBoxFooterType } from "~/core";
import * as analysisActions from "./actions";
import { messages } from "../i18n-messages";
import { LayerAPI } from "@ai360/core";
import { selectors as cdSelectors } from "~/customer-data";
import * as models from "~/customer-data/models";

interface IAnalysisBatchEditDialogBoxProps {
    closeConfirmDialog: () => void;
    fieldMap: Immutable.Map<string, models.FieldInfo>;
    intl: InjectedIntl;
    isConfirmationModalOpen: boolean;
    onEditSingle: () => void;
    onEditBatch: () => void;
    onEditAnalysisLayerBatch: (
        batchGuid: string,
        analysisInBatch: LayerAPI.IAnalysisInBatch[]
    ) => void;
    surfaceInfo: LayerAPI.ISubLayer;
}

const AnalysisBatchEditDialogBox = (props: IAnalysisBatchEditDialogBoxProps): JSX.Element => {
    const {
        closeConfirmDialog,
        fieldMap,
        isConfirmationModalOpen,
        intl,
        onEditSingle,
        onEditBatch,
        surfaceInfo,
    } = props;
    const { formatMessage } = intl;

    const body = formatMessage(messages.editMultipleBody, {
        analysisLayerName: surfaceInfo.analysisLayerName,
        fieldName: surfaceInfo.fieldName,
    });
    const farmFieldNames = surfaceInfo.analysisInBatch.map((x) => {
        const farmName = fieldMap.get(x.fieldGuid)?.farmName
            ? `${fieldMap.get(x.fieldGuid)?.farmName} - `
            : "";
        return `${farmName}${x.fieldName}`;
    });
    const sortedFieldNames = farmFieldNames.sort((a, b) => a.localeCompare(b));
    const fieldNameElements = sortedFieldNames.map((x, i) => (
        <li className="list-item" key={i}>
            {x}
        </li>
    ));

    const onEditAll = () => {
        onEditBatch();
        closeConfirmDialog();
    };

    return (
        <DialogBox
            className="surface-layer-context-menu-batch-dialog-box"
            footerType={DialogBoxFooterType.MULTI_ACTION}
            isOpen={isConfirmationModalOpen}
            multiActionList={[
                {
                    action: formatMessage(messages.editAllButton),
                    actionDisabled: false,
                    onAction: () => onEditAll(),
                },
                {
                    action: formatMessage(messages.editSingleButton),
                    actionDisabled: false,
                    onAction: () => onEditSingle(),
                },
                {
                    action: formatMessage(messages.cancel),
                    actionDisabled: false,
                    isCancelStyle: true,
                    onAction: () => closeConfirmDialog(),
                },
            ]}
            title={formatMessage(messages.confirmDeleteTitle)}
        >
            <div className="body">{body}</div>
            <ul className="list">{fieldNameElements}</ul>
        </DialogBox>
    );
};
const mapStateToProps = (state, props: Partial<IAnalysisBatchEditDialogBoxProps>) => ({
    ...props,
    fieldMap: cdSelectors.getFieldMap(state),
});

const mapDispatchToProps = (dispatch) => ({
    onShowAnalysisLayer: (analysisInfoGuid) =>
        dispatch(analysisActions.showAnalysisInfo(analysisInfoGuid)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AnalysisBatchEditDialogBox));
